import Price from '../Price';
import Volume from '../Volume';
import {
  NumberInput,
  Switch,
  Typography,
  Stack,
  Box,
  Divider,
  Paper,
} from '@newulife/common'
import { FormControlLabel } from '@mui/material'
import formatImageSrc from 'helpers/formatImageSrc'

export default function ProductQtyOnlyCard({
  subscribeText,
  centered = false,
  imgSrc,
  imgAlt,
  title,
  cv,
  qv,
  price,
  qty,
  maxQty,
  decrement,
  increment,
}) {
  return (
    <Paper
      className="product-qty-only-card"
      elevationVariant="card"
      active={qty > 0}
      data-testid={`${title?.replace(/\W/g, '')}-card`}
      sx={{
        display: 'inline-grid',
        width: '100%',
        height: '100%',
      }}
    >
      <Stack
        display="grid"
        justifySelf="center"
        gridTemplateRows="1fr auto auto"
        p={{
          xs: 1.5,
          md: 2,
        }}
        pb={0}
        height="100%"
        width="100%"
        maxWidth="340px"
      >
        <Stack
          display="grid"
          gap={{
            md: 3,
          }}
          gridTemplateColumns={{
            md: 'auto 1fr',
          }}
          mb={2}
          justifyItems={{
            xs: 'center',
            md: 'initial',
          }}
        >
          <Box
            width="120px"
            height="120px"
            sx={{
              'img': {
                width: '100%',
                height: 'auto',
              },
            }}
          >
            <img src={formatImageSrc(imgSrc)} alt={imgAlt} />
          </Box>
          <Stack
            gap={1}
          >
            <Typography
              variant="body2"
              textAlign="center"
            >
              {title}
            </Typography>
            <Divider
              light
            />
            {cv && qv && (
              <>
                <Stack
                  color="#747679"
                  gap={.5}
                >
                  <Typography
                    variant="subbody2"
                  >
                    <Volume type="cv" value={cv} />
                  </Typography>
                  <Typography
                    variant="subbody2"
                  >
                    <Volume type="qv" value={qv} />
                  </Typography>
                </Stack>
                <Divider
                  light
                />
              </>
            )}
            <Typography
              data-testid={`${title?.replace(/\W/g, '')}-price`}
              variant="header2"
              color="neutralCool.dark"
              sx={{
                fontWeight: 500,
              }}
            >
              <Price value={price} />
            </Typography>
          </Stack>
        </Stack>
        <Divider
          light
          sx={{
            mb: 2,
          }}
        />
        <Stack
          direction="row"
          justifyContent={centered ? 'center' : 'space-between'}
        >
          <NumberInput
            data-testid={`${title?.replace(/\W/g, '')}-footer`}
            min={0}
            max={maxQty}
            value={qty}
            onChange={data => {
              data > qty ? increment() : decrement()
            }}
            IconButtonProps={{
              sx: { // app.min.css breaks the button states
                '&:active, &:focus, &:hover': {
                  backgroundColor: '#fff',
                  color: '#7ab800',
                },
              },
            }}
          />
          {title === 'New U Life Connect Mobile App Monthly Subscription' && (
            <FormControlLabel
              control={
                <Switch
                  checked
                  disabled
                />
              }
              label={
                <Typography
                  variant="subbody2"
                  color="neutralCool.dark"
                >
                  {subscribeText}
                </Typography>
              }
              sx={{
                ':has(.Mui-disabled)': {
                  opacity: .4,
                },
              }}
            />
          )}
        </Stack>
      </Stack>
    </Paper>
  );
}
